// extracted by mini-css-extract-plugin
export default {"card":"assessment_card__N1BxO","completed":"assessment_completed__mdFmX","cards":"assessment_cards__cP1qf"};